<template>
  <svg
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="17"
      height="17"
      rx="3.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="17"
      height="17"
      rx="3.5"
      stroke="#D3D5E5"
    />
  </svg>
</template>
